// extracted by mini-css-extract-plugin
module.exports = {"LogoutPage":"LogoutPage_LogoutPage__1GvPk"};